export default {
  masterChef: {
    56: '0xcC85666f507059A351942eaDfd759106623eACB1',
    8453: '0xcC85666f507059A351942eaDfd759106623eACB1',
    97: '0x6e1a522fcEbcF5C004922ECBbEe13A0F73B3E080',
  },
  masterChefV1: {
    56: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
    8453: '0xcC85666f507059A351942eaDfd759106623eACB1',
    97: '',
  },
  sousChef: {
    56: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
    8453: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    97: '',
  },
  lotteryV2: {
    56: '0x5aF6D33DE2ccEC94efb1bDF8f92Bd58085432d2c',
    8453: '0x5790c3534F30437641541a0FA04C992799602998',
    97: '',
  },
  // TODO: multi
  multiCall: {
    56: '0xcf591ce5574258ac4550d96c545e4f3fd49a74ec',
    8453: '0xE5337e422302F1678A658D025F31F89e898Eeb69',
    97: '0xa54fE4a3DbD1Eb21524Cd73754666b7E13b4cB18',
  },
  pancakeProfile: {
    56: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    8453: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
    97: '',
  },
  pancakeBunnies: {
    56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    8453: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
    97: '',
  },
  bunnyFactory: {
    56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    8453: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
    97: '',
  },
  claimRefund: {
    56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    8453: '',
    97: '',
  },
  pointCenterIfo: {
    56: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    8453: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
    97: '',
  },
  bunnySpecial: {
    56: '0xFee8A195570a18461146F401d6033f5ab3380849',
    8453: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
    97: '',
  },
  tradingCompetitionEaster: {
    56: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    8453: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
    97: '',
  },
  tradingCompetitionFanToken: {
    56: '0xA8FECf847e28aa1Df39E995a45b7FCfb91b676d4',
    8453: '',
    97: '',
  },
  tradingCompetitionMobox: {
    56: '0x1C5161CdB145dE35a8961F82b065fd1F75C3BaDf',
    8453: '',
    97: '',
  },
  tradingCompetitionMoD: {
    56: '0xbDd9a61c67ee16c10f5E37b1D0c907a9EC959f33',
    8453: '',
    97: '',
  },
  easterNft: {
    56: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    8453: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
    97: '',
  },
  cakeVault: {
    56: '0x45c54210128a065de780C4B0Df3d16664f7f859e',
    8453: '',
    97: '',
  },
  cakeFlexibleSideVault: {
    56: '0x615e896A8C2CA8470A2e9dc2E9552998f8658Ea0',
    8453: '',
    97: '',
  },
  predictionsBNB: {
    56: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    8453: '',
    97: '',
  },
  predictionsCAKE: {
    56: '0x0E3A8078EDD2021dadcdE733C6b4a86E51EE8f07',
    8453: '',
    97: '',
  },
  chainlinkOracleBNB: {
    56: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    8453: '',
    97: '',
  },
  chainlinkOracleCAKE: {
    56: '0xB6064eD41d4f67e353768aA239cA86f4F73665a1',
    8453: '',
    97: '',
  },
  predictionsV1: {
    56: '0x516ffd7d1e0ca40b1879935b2de87cb20fc1124b',
    8453: '',
    97: '',
  },
  bunnySpecialCakeVault: {
    56: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    8453: '',
    97: '',
  },
  bunnySpecialPrediction: {
    56: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    8453: '',
    97: '',
  },
  bunnySpecialLottery: {
    56: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    8453: '0x382cB497110F398F0f152cae82821476AE51c9cF',
    97: '',
  },
  bunnySpecialXmas: {
    56: '0x59EdDF3c21509dA3b0aCCd7c5ccc596d930f4783',
    8453: '',
    97: '',
  },
  farmAuction: {
    56: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    8453: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
    97: '',
  },
  AnniversaryAchievement: {
    56: '0x787980da5491118C3cB33B21aB50c8c379D2C552',
    8453: '0x981aE96378e770DE44F89cD9175E708f9EDB70a9',
    97: '',
  },
  nftMarket: {
    56: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    8453: '0x7f9f37ddcaa33893f9beb3d8748c8d6bfbde6ab2',
    97: '',
  },
  nftSale: {
    56: '0x29fE7148636b7Ae0b1E53777b28dfbaA9327af8E',
    8453: '0xe486De509c5381cbdBF3e71F57D7F1f7570f5c46',
    97: '',
  },
  pancakeSquad: {
    56: '0x0a8901b0E25DEb55A87524f0cC164E9644020EBA',
    8453: '0xfC0c3F11fDA72Cb9A56F28Ec8D44C0ae4B3ABF86',
    97: '',
  },
  // TODO: multi
  zap: {
    56: '0xD4c4a7C55c9f7B3c48bafb6E8643Ba79F42418dF',
    8453: '0xD85835207054F25620109bdc745EC1D1f84F04e1',
    97: '',
  },
  iCake: {
    56: '0x3C458828D1622F5f4d526eb0d24Da8C4Eb8F07b1',
    8453: '',
    97: '',
  },
}
